import { CommonModule } from "@angular/common";
import { Component, Inject } from "@angular/core";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { PersonSearchComponent } from "../../../shared/person-search/person-search.component";
import { IPerson } from "../../../models/person.model";
import { MatIconModule } from "@angular/material/icon";
import { LoggedInUserService } from "../../../services/common/logged-in-user.service";
import { ILoggedInUser } from "../../../interfaces/common/loggedInUser";
import { EmployeeBankAccountService } from "../../services/employee-bank-account.service";

@Component({
  selector: "manage-employee-bank-account",
  templateUrl: "./manage-employee-bank-account.component.html",  
  standalone: true,  
  imports: [CommonModule,MatIconModule, MatProgressSpinnerModule, ReactiveFormsModule,PersonSearchComponent],
})
export class ManageEmployeeBankAccountComponent {
  title: string  = "";
  buttonName:string = "";
  form: FormGroup;
  user: ILoggedInUser;
  isAdmin: boolean = false;
  employeeBankAccountModel: EmployeeBankAccountModel;
  information: string = "";
  isAdding: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public employeeNo: number,    
    public dialogRef: MatDialogRef<ManageEmployeeBankAccountComponent>,
    private fb: FormBuilder,    
    private userService: LoggedInUserService,    
    private employeeBankAccountService: EmployeeBankAccountService,  
  ) {}

  ngOnInit(): void {
    if(this.employeeNo <= 0){
      this.isAdding = true;
    }

    this.userService.currentUser$.subscribe(data => {
      this.user = data;
      if(this.user != null && this.user.adminRight){
        this.isAdmin = this.user.adminRight;
        this.getEmployeeBankAccount();
      }      
    });

    if(this.isAdding){
      this.buttonName = "Add";
      this.title = "New Bank Account Entry";      
    } else {
      this.buttonName = "Update";
      this.title = "Edit Bank Account Entry";
    }

    this.form = this.fb.group({
      employeeNo: new FormControl(''),
      employeeName: new FormControl(''),
      account: new FormControl(''),
      cardNumber:new FormControl('')
    });
  }

  getEmployeeBankAccount(){
    if(!this.isAdding){
      this.employeeBankAccountService.searchBankAccount(this.employeeNo).subscribe(data => { 
        this.employeeBankAccountModel = data;
        this.form.patchValue(data);
      });
    }    
  }

  patchValues(){
    this.form.patchValue({
      employeeNo: this.employeeBankAccountModel.employeeNo,
      employeeName: this.employeeBankAccountModel.employeeName,
      account: this.employeeBankAccountModel.account,
      cardNumber: this.employeeBankAccountModel.cardNumber
    });
  }  

  getformValues(): ManageEmployeeBankAccountModel{
    return {
      employeeNo: this.form.get('employeeNo').value,
      employeeName: this.form.get('employeeName').value,
      account: this.form.get('account').value,
      dateVerified: new Date(),
      cardNumber: this.form.get('cardNumber').value,
      userEmail: this.user.userEmail,
      UserName: this.user.userName
    };
  }

  startAction(){
    if(!this.isAdding){      
      this.employeeBankAccountService.updateBankAccount(this.getformValues()).subscribe({
        next: (result) => {
          if (result.isSuccess) {
            this.information = "Bank Account Updated";
          } else {
            this.information = result.error.description;
          }
        },
        error: (err) => {
          console.error('Error updating bank account:', err);
          this.information = 'An error occurred while updating the bank account.';
        }
      });

    }
    else{
      this.employeeBankAccountService.addBankAccount(this.getformValues()).subscribe(result => {
        if(result.isSuccess){
          this.information = "Bank Account Added";
        }else{
          this.information = result.error.description;
        }
      })
    }
  }

  onEmployeeSelected(person: IPerson){
    this.form.get('employeeNo').patchValue(person.id.toString());
    this.form.get('employeeName').patchValue(person.fullName.toString());
  }

  onEmployeeClear(){
    this.form.get('employeeNo').setValue('');
    this.form.get('employeeName').setValue('');
  }

  delete(){
    this.employeeBankAccountService.deleteBankAccount(this.getformValues()).subscribe(result => {
      if(result.isSuccess){
        this.information = "Bank Account Deleted";
      }else{
        this.information = result.error.description;
      }      
    })
  }

  close() {
    this.dialogRef.close();
  }   
}
